import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { Box, Button, Typography } from '@mui/material';

import { useTranslation } from 'react-i18next';

export default function StepNavigator({
  currentStep,
  totalSteps,
  onPrev,
  onNext,
}) {
  const { t } = useTranslation(['onboarding']);

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        mt: 3,
      }}
    >
      <Button
        onClick={onPrev}
        disabled={currentStep === 0}
        startIcon={<ChevronLeftIcon />}
        sx={{
          textTransform: 'uppercase',
          fontWeight: 500,
          color: currentStep === 0 ? 'text.disabled' : 'primary.main',
        }}
      >
        {t('training.section.nav.prev')}
      </Button>

      <Typography variant="body2" color="text.secondary">
        {currentStep + 1}/{totalSteps}
      </Typography>

      <Button
        onClick={onNext}
        disabled={currentStep === totalSteps - 1}
        endIcon={<ChevronRightIcon />}
        sx={{
          textTransform: 'uppercase',
          fontWeight: 500,
          color:
            currentStep === totalSteps - 1 ? 'text.disabled' : 'primary.main',
        }}
      >
        {t('training.section.nav.next')}
      </Button>
    </Box>
  );
}
